/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Next_TagInputs */

const en_hero_next_tag = /** @type {(inputs: Hero_Next_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next open time`)
};

const pl_hero_next_tag = /** @type {(inputs: Hero_Next_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najbliższy wolny termin`)
};

/**
* | output |
* | --- |
* | "Next open time" |
*
* @param {Hero_Next_TagInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_next_tag = /** @type {((inputs?: Hero_Next_TagInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Next_TagInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_next_tag(inputs)
	return en_hero_next_tag(inputs)
});